import React from 'react';
import './Blog.css';

const posts = [
  {
    title: 'The Research Topic Hunt That Almost Broke Me 😩',
    excerpt: 'From feeling completely lost to facing a mountain of research, here is the real story of my first week trying to find a meaningful topic.',
    url: 'https://medium.com/@Bijonn/the-research-topic-hunt-that-almost-broke-me-de653ad20dcd',
    date: 'Apr 6, 2026',
    reactions: 9,
    comments: 1,
  },
  {
    title: 'GitHub Took Opus From Students. Now I\'m Writing Code Manually.',
    excerpt: 'A student\'s story of watching the best AI tools disappear, one update at a time.',
    url: 'https://medium.com/@Bijonn/github-took-opus-from-students-now-im-writing-code-manually-e13f423a1c47',
    date: '2 days ago',
    reactions: null,
    comments: null,
  },
  {
    title: '"When Life Says \'Focus\', But You Open 10 Tabs Anyway 😬"',
    excerpt: 'Trying to balance work, university, and research… while everything competes for attention like a browser full of chaos.',
    url: 'https://medium.com/@Bijonn/when-life-says-focus-but-you-open-10-tabs-anyway-f8b7ee8e06d9',
    date: 'Apr 30, 2026',
    reactions: null,
    comments: null,
  },
  {
    title: 'I Chose AI… Unfortunately, My Laptop Did Not Agree 🤖🤕',
    excerpt: 'Small storage problem turned into a three-week research adventure.',
    url: 'https://medium.com/@Bijonn/i-chose-ai-unfortunately-my-laptop-did-not-agree-b6abec804a1a',
    date: 'Apr 7, 2026',
    reactions: 6,
    comments: null,
  },
];

const linkedinPosts = [
  'https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7412847410550386688?collapsed=1',
  'https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7373256906410258432?collapsed=1',
  'https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7383784153701462016?collapsed=1',
];

const Blog = () => {
  return (
    <section id="blog" className="sec">
      <div className="sec-inner">
        <div className="sec-label">08 — Writing</div>
        <h2 className="sec-title">Thoughts I put<br/><em>into words</em></h2>

        {/* Medium Posts */}
        <div className="blog-grid reveal">
          {posts.map((post, i) => (
            <a href={post.url} target="_blank" rel="noopener noreferrer" className="blog-card" key={i}>
              <div className="blog-card-num">{String(i + 1).padStart(2, '0')}</div>
              <div className="blog-card-content">
                <div className="blog-card-meta">
                  <span className="blog-card-source">Medium</span>
                  <span className="blog-card-date">{post.date}</span>
                </div>
                <div className="blog-card-title">{post.title}</div>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <div className="blog-card-footer">
                  {post.reactions && <span className="blog-stat">♥ {post.reactions}</span>}
                  {post.comments && <span className="blog-stat">💬 {post.comments}</span>}
                  <span className="blog-read-more">Read on Medium ↗</span>
                </div>
              </div>
            </a>
          ))}
        </div>
        {/* LinkedIn Featured Posts */}
        <div className="linkedin-section">
          <div className="linkedin-header">
            <span className="linkedin-badge">Featured on LinkedIn</span>
          </div>
          <div className="linkedin-grid">
            {linkedinPosts.map((src, i) => (
              <div className="linkedin-embed-wrap" key={i}>
                <iframe
                  src={src}
                  height="500"
                  width="100%"
                  frameBorder="0"
                  allowFullScreen
                  title={`LinkedIn post ${i + 1}`}
                  loading="lazy"
                ></iframe>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
